import { ToolbarState } from './toolbarTypes';

export enum CurrentToolbarActionType {
    TOOLBAR_STATE_UPDATE = 'TOOLBAR_STATE_UPDATE',
}

export type CurrentToolbarUpdatedAction = {
    type: CurrentToolbarActionType;
    toolbarState: ToolbarState;
};

export const updateToolbarState = (toolbarState: ToolbarState): CurrentToolbarUpdatedAction => ({
    type: CurrentToolbarActionType.TOOLBAR_STATE_UPDATE,
    toolbarState,
});
